<style scoped lang="scss">
    .info-wrapper {
        p {
            margin: 0;
        }
    }
    .select-wrapper {
        label {
            padding-left: 10px;
        }
        input {
            margin-left: 20px;
        }
    }
</style>

<template>
    <div class="uk-width-1-1">
        <div class="uk-grid">
            <div class="uk-width-1-1 info-wrapper">
                <p v-html="__('tenant.inc_household_member_name', { label: label} )"></p>
                <p v-html="__('tenant.inc_property_address', { address: propertyAddress })"></p>
            </div>
            <div class="uk-width-1-1 uk-margin-top">
                <p><b>{{ __('tenant.inc_within_last_30_days') }}</b></p>
                <table class="uk-table uk-hidden-small uk-table-striped">
                    <thead>
                    <tr>
                        <th>{{ __('tenant.inc_income_type') }}</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, idx) in incomes">
                        <td width="70%">{{ item.label }}</td>
                        <td>
                            <div class="uk-margin-top select-wrapper" v-if="item.id == 'other_source'">
                                <input type="radio" :id="`yes_${idx}_${member.id}`" :name="`action_select_${idx}_${member.id}`"  :value="true" v-model="item.val" @change="onChangeRadio(idx)"><label :for="`yes_${idx}`">{{ __('global.yes') }}</label>
                                <input type="radio" :id="`no_${idx}_${member.id}`" :name="`action_select_${idx}_${member.id}`" :value="false" v-model="item.val" @change="onChangeRadio(idx)"><label :for="`no_${idx}`">{{ __('global.no') }}</label>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="uk-width-1-1 uk-margin-large-top">
                <p v-html="__('tenant.inc_under_penalty', {program_abbreviation: program.program_abbreviation, agency: program.agency_short_name })"></p>
                <div class="uk-width-1-1 uk-margin-top" v-if="programSettings['uses-esign-no-income']">
                    <validated-section field="signature_no_income" :errors="errors">
                        <signature-box @updated="onSignatureUpdated"
                                        :user-key="member.id"
                                        :is-signed="signatureData[member.id] && signatureData[member.id].signed_at !== null"
                                        :completed="signatureData[member.id] && signatureData[member.id].completed"
                                        :name="member.first_name + ' ' + member.last_name"
                                        :color="programSettings['primary-program-color']"
                        ></signature-box>
                    </validated-section>
                </div>
                <div v-else class="uk-width-1-1 uk-margin-top">
                    <DocRequest
                        :applicationId="application.id"
                        :member="member"
                        :incomes="incomes"
                        docType="no-income-hh"
                    ></DocRequest>
                </div>
            </div>
        </div>
        <modal-dialog
            :title="__('global.confirmation')"
            ref="confirmModal"
            @close="onCloseModalConfirm"
            @confirm="onCompleteModalConfirm"
            confirmText="Okay"
            :showCancelButton="false"
        >
            {{ __('tenant.inc_please_return') }}
        </modal-dialog>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    // import moment from 'moment';
    import ValidatedSection from "../../../../../../components/Common/ValidatedSection";
    import PreviewDocumentModal from "../../../../../../../dashboard/pages/Documents/PreviewDocumentModal";
    import SignatureBox from "../../../../../../components/AppWizard/SignatureBox";
    import DocRequest from "./DocRequest";
    import ModalDialog from "../../../../../../components/Common/ModalDialog";

    export default {
        name: "NoIncomeHHForm",
        props: {
            label: {
                type: String,
                default: ''
            },
            member: {
                type: Object,
                default: {}
            },
            members: {
                type: Array,
                default: []
            },
            url: {
                type: String,
                default: ''
            },
        },
        components: {
            ValidatedSection,
            PreviewDocumentModal,
            SignatureBox,
            ModalDialog,
            DocRequest
        },
        computed: {
            ...mapState('Application', {
                application: 'application',
                applicant: 'applicant',
            }),
            ...mapGetters('Application', [
                'program',
                'programSettings'
            ]),
            propertyAddress() {
                let result = ''
                if (this.applicant.property_address)
                {
                    result = `${this.applicant.property_address.line_1} ${this.applicant.property_address.line_2}, ${this.applicant.property_address.city}, ${this.applicant.property_address.state}, ${this.applicant.property_address.zip}`
                }
                return result
            }
        },
        data() {
            return {
                errors: {},
                signatureData: {},
                selectedIndex: null,
                incomes: [
                    {
                        id: 'other_source',
                        label: this.__('tenant.inc_ni_i_have'),
                        val: false
                    },
                    {
                        id: 'wages',
                        label: this.__('tenant.inc_ni_wages'),
                        val: false
                    },
                    {
                        id: 'service_pay',
                        label: this.__('tenant.inc_ni_severance'),
                        val: false
                    },
                    {
                        id: 'worker-compensation',
                        label: this.__('tenant.inc_ni_workers_comp'),
                        val: false
                    },
                    {
                        id: 'interest',
                        label: this.__('tenant.inc_ni_interest'),
                        val: false
                    },
                    {
                        id: 'net-income',
                        label: this.__('tenant.inc_ni_net_income'),
                        val: false
                    },
                    {
                        id: 'self-employment',
                        label: this.__('tenant.inc_ni_self_employment'),
                        val: false
                    },
                    {
                        id: 'unemployment-benefit',
                        label: this.__('tenant.inc_ni_unemployment'),
                        val: false
                    },
                    {
                        id: 'ssi',
                        label: this.__('tenant.inc_ni_soc_sec'),
                        val: false
                    },
                    {
                        id: 'annuities',
                        label: this.__('tenant.inc_ni_annuities'),
                        val: false
                    },
                    {
                        id: 'insurance',
                        label: this.__('tenant.inc_ni_insurance'),
                        val: false
                    },
                    {
                        id: 'alimony',
                        label: this.__('tenant.inc_ni_alimony'),
                        val: false
                    },
                    {
                        id: 'regular_contribution',
                        label: this.__('tenant.inc_ni_contributions'),
                        val: false
                    },
                    {
                        id: 'tanf',
                        label: this.__('tenant.inc_ni_temporary'),
                        val: false
                    },
                    {
                        id: 'all_regular_pay',
                        label: this.__('tenant.inc_ni_all_regular'),
                        val: false
                    }
                ],
            }
        },
        watch: {
            'member.signatures': {
                handler: function (newValue) {
                    if(newValue.household) {
                        this.initData();
                    }
                },
                deep: true
            },
            application(newValue) {
                if(newValue.household) {
                    this.initData();
                }
            }
        },
        mounted() {
            this.initData()
        },
        methods: {
            initData() {
                this.signatureData = {}
                const signatureFiltered = this.member.signatures.find(item => item.key === `no-income-hh`)
                if(signatureFiltered) {
                    this.$set(this.signatureData, this.member.id, { signed_at: signatureFiltered.created_at, completed: true });
                }
            },

            onSignatureUpdated($event) {
                if(!this.signatureData[$event.key]) {
                    this.$set(this.signatureData, $event.key, {});
                }
                this.$set(this.signatureData, $event.key, { signed_at: $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null});
            },

            onCloseModalConfirm() {

            },

            onCompleteModalConfirm() {
                setTimeout(() => {
                    this.$emit('confirmSelect', {
                        member: this.member,
                        incomeIndex: this.selectedIndex,
                    });
                }, 500)
            },

            onChangeRadio(index) {
                if (this.incomes[index].val === true)
                {
                    this.selectedIndex = index
                    this.$refs.confirmModal.open();
                }
            },

            validate() {
                this.errors = {};
                let stepValid = true;
                if (this.programSettings['uses-esign-no-income'])
                {
                    if(!this.signatureData[this.member.id]) {
                        this.errors['signature_no_income'] = {
                            errors: [this.member.first_name + ' ' + this.member.last_name + ' must sign this form as their name appears above.'],
                        };
                    }else if(this.signatureData[this.member.id] && this.signatureData[this.member.id].signed_at == null) {
                        this.errors['signature_no_income'] = {
                            errors: [this.member.first_name + ' ' + this.member.last_name + ' must sign this form as their name appears above.'],
                        };
                    }
                }

                let errorCount = _.size(this.errors);

                if(errorCount > 0) stepValid = false;

                return stepValid
            },
        }
    }
</script>
